import * as Sentry from '@sentry/browser';


const logError = (error, info) => {
  Sentry.withScope(scope => {
    if (info) {
      Object.keys(info).forEach(key => {
        scope.setExtra(key, info[key]);
      });
    }
    Sentry.captureException(error);
  });
};

export default logError;



// WEBPACK FOOTER //
// ./src/utils/error.js